module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "data-item"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDataForClients(_vm.data.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Введите название"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), (!_vm.data.file) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("Добавить файл")]) : _c('span', [_c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm._f("path")(_vm.data.file)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-file",
    on: {
      "click": function($event) {
        return _vm.deleteDataForClientsFile(_vm.data.id)
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch"
  }, [_c('b-switch', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.data.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.data, "isHidden", $$v)
      },
      expression: "data.isHidden"
    }
  }, [_vm._v("Скрыть с сайта")])], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72c36401"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/SoftItem.vue
// module id = 967
// module chunks = 0